import { USD_MOCK_TOKEN } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { getTokenImage } from '@/ui/assets/tokens'
import { PageHeroStats } from '@/ui/molecules/page-hero/PageHeroStats'
import Image from 'next/image'
import { useSummaryInfo } from '../logic/useSummaryInfo'

export function UsdxlHeroStats() {
  const { totalSupply, reserveBalanceUSD } = useSummaryInfo()

  const stats = [
    {
      label: 'Total Supply',
      value: USD_MOCK_TOKEN.format(totalSupply, { style: 'compact' }),
      icon: (
        <Image
          src={getTokenImage(TokenSymbol('USDXL'))}
          className="h-5 w-5 rounded-full"
          width={20}
          height={20}
          alt="USDXL"
        />
      ),
    },
    ...(reserveBalanceUSD
      ? [
          {
            label: 'Reserve',
            value: USD_MOCK_TOKEN.format(reserveBalanceUSD, { style: 'compact' }),
            icon: (
              <Image
                src={getTokenImage(TokenSymbol('USDT0'))}
                className="h-5 w-5 rounded-full"
                width={20}
                height={20}
                alt="USDT0"
              />
            ),
          },
        ]
      : []),
  ]

  return <PageHeroStats stats={stats} loading={false} />
}
